"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_provider = _interopRequireDefault(require("./_basic_provider"));
class EmailApi extends _basic_provider.default {
  /**
   * Represents an Email Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      httpGatewayUrl,
      sendWSMessage
    } = _ref;
    super({
      userTokenFactory,
      sdkApiUrl,
      providersAccountId,
      httpGatewayUrl,
      sendWSMessage
    });
  }

  /**
   * @param {String} param0.path provider url
   */
  async getEmailSettings(path) {
    return await this._callApi({
      method: 'get',
      path,
      errorName: 'EmailError_getEmailSettings'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async getEmailIdentifiers(path, payload) {
    return await this._callApi({
      method: 'post',
      path,
      payload,
      errorName: 'EmailError_getEmailIdentifiers'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async registerBotmailAccount(path, payload) {
    return await this._callApi({
      method: 'post',
      path,
      payload,
      errorName: 'EmailError_registerBotmailAccount'
    });
  }

  /**
  * @param {String} param0.path provider url
  * @param {Object} param0.payload request params
  */
  async checkIMAPCredentials(path, payload) {
    return await this._callApi({
      method: 'post',
      path,
      payload,
      errorName: 'EmailError_checkIMAPCredentials'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async checkSMTPCredentials(path, payload) {
    return await this._callApi({
      method: 'post',
      path,
      payload,
      errorName: 'EmailError_checkSMTPCredenntials'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async createIMAPAccount(path, payload) {
    return await this._callApi({
      method: 'post',
      path,
      payload: {
        accountId: payload.accountId,
        requestedAccount: payload.requestedAccount
      },
      errorName: 'EmailError_createIMAPAccount'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async updateIMAPAccount(path, payload) {
    return await this._callApi({
      method: 'put',
      path,
      payload: {
        accountId: payload.accountId,
        requestedEmail: payload.requestedEmail
      },
      errorName: 'EmailError_updateIMAPAccount'
    });
  }

  /**
   * @param {String} param0.path provider url
   * @param {Object} param0.payload request params
   */
  async deleteEmailAccount(path, payload) {
    return await this._callApi({
      method: 'delete',
      path,
      payload: {
        accountId: payload.accountId,
        requestedEmail: {
          id: payload.id,
          address: payload.address
        }
      },
      errorName: 'EmailError_deleteEmailAccount'
    });
  }
}
var _default = EmailApi;
exports.default = _default;